import {
    ApplicationConfig,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
    inject,
} from '@angular/core';
import {
    provideRouter,
    withHashLocation,
    withComponentInputBinding,
    withNavigationErrorHandler,
    NavigationError,
} from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental';

import { providePrimeNG } from '@gomaterials/ui-components/config';
import { DialogOutletService, MessageService } from '@gomaterials/ui-components/api';
import { GoMatDefault } from '@gomaterials/ui-components';

import {
    authInterceptor,
    apimSubscriptionKeyInterceptor,
    errorInterceptor,
    loggerInterceptor,
} from '@core/interceptors';
import { ReloadPromptService } from '@core/services';
import { isChunkLoadError } from '@core/utils';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withNavigationErrorHandler((event: NavigationError) => {
                if (isChunkLoadError(event.error)) {
                    inject(ReloadPromptService).show();
                    return;
                }
            }),
            withHashLocation(),
            withComponentInputBinding()
        ),
        provideHttpClient(
            withInterceptors([authInterceptor, apimSubscriptionKeyInterceptor, errorInterceptor, loggerInterceptor])
        ),
        provideTanStackQuery(
            new QueryClient({
                defaultOptions: {
                    queries: {
                        retry: false,
                        refetchOnWindowFocus: false,
                        staleTime: 0,
                    },
                },
            })
        ),
        providePrimeNG({
            theme: {
                preset: GoMatDefault,
                options: {
                    cssLayer: {
                        name: 'primeui',
                        order: 'theme, base, primeui, primeui-patch',
                    },
                    darkModeSelector: false,
                },
            },
        }),
        DialogOutletService,
        MessageService,
    ],
};
